export const DEFAULT_SUBDOMAIN = 'default';
export const BUSINESS_SUBDOMAIN = 'business';

export const SUBDOMAINS = [DEFAULT_SUBDOMAIN, BUSINESS_SUBDOMAIN] as const;
export type Subdomain = typeof SUBDOMAINS[number];
